// Full-viewport quiet brand pulse for boot states (session check, device
// list) — the app frame never flashes while its prerequisites load.
export function BrandPulse() {
  return (
    <div role="status" className="flex min-h-dvh items-center justify-center">
      <span aria-hidden className="animate-pulse text-2xl text-spark">
        ✦
      </span>
      <span className="sr-only">Loading</span>
    </div>
  );
}
